import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";

import EventTimezoneSupplyPanel from "./EventTimezoneSupplyPanel";
import InsightsErrorBoundary from "./InsightsErrorBoundary";
import MemberZonePanel from "./MemberZonePanel";
import ZonePerformancePanel from "./ZonePerformancePanel";

/**
 * Event Insights — the Events page "Insights" view. A port of the member tools'
 * Zone Performance tab, in three sections:
 *   • Zone performance — Zone × Event-Type participation & show-up rates
 *   • Members by zone  — where members sit across the time-of-day zones
 *   • Events by timezone — upcoming events in members' local time, with reach
 *
 * Each section loads only when its tab is opened, so the heavier warehouse-style
 * queries run on demand rather than all at once.
 */
const EventInsights: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Typography variant="body2" color="textSecondary" mb={2}>
        How your events and members line up across the eight 3-hour UTC colour zones — which zones
        convert, where your members actually are, and where the upcoming schedule leaves gaps. (A
        zone is a fixed UTC slot, not a local time of day — “Zone performance” shows what local time
        each is in your biggest regions.)
      </Typography>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Zone performance" />
        <Tab label="Members by zone" />
        <Tab label="Events by timezone" />
      </Tabs>

      <InsightsErrorBoundary key={tab}>
        {tab === 0 && <ZonePerformancePanel />}
        {tab === 1 && <MemberZonePanel />}
        {tab === 2 && <EventTimezoneSupplyPanel />}
      </InsightsErrorBoundary>
    </Box>
  );
};

export default EventInsights;
